
import React from 'react'
import { Icon } from '@/components/ui/icon'
import type { User } from 'better-auth/types'
import { NavUser } from './nav-user'

interface SidebarFooterProps {
  openSettings: () => void
  user: User | null
  onLogout: () => void
}

export const SidebarFooter: React.FC<SidebarFooterProps> = ({ openSettings, user, onLogout }) => {
  if (!user) return null

  return (
    <div className="px-2 pb-2">
      <NavUser
        user={{
          name: user.name || user.email?.split('@')[0] || 'User',
          email: user.email || '',
          avatar: user.image || undefined,
        }}
        onLogout={onLogout}
      />
    </div>
  )
}
